import { render, staticRenderFns } from "./CreateDevolutionContent.vue?vue&type=template&id=d7d21672&scoped=true"
import script from "./CreateDevolutionContent.vue?vue&type=script&lang=js"
export * from "./CreateDevolutionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d21672",
  null
  
)

export default component.exports